import { API } from "@project/shared"

export const createDataBackup = async () => {
  return API.post("/data-backup")
}

export const getAllDataBackups = async () => {
  return API.get("/data-backup")
}
